/* eslint class-methods-use-this: 0 */
import React from 'react';
import { Modal, Button, Row, Col } from 'react-bootstrap';
import _ from 'underscore';
import SelectReasonCodes from 'components/modules/marketplace-config/SelectReasonCodes';
import { withTranslation } from 'react-i18next';
const cancelReasons = [
    { value: 'Duplicate', name: 'Duplicate' },
    { value: 'Missed Pickup', name: 'Missed Pickup' },
    { value: 'Re-Schedule', name: 'Re-Schedule' },
    { value: 'Carrier Mistake', name: 'Carrier Mistake' },
    { value: 'Shipper Request', name: 'Shipper Request' },
    { value: 'Will Not Reexpose', name: 'Will Not Reexpose' },
];
class CancelShipmentModal extends React.Component {
    constructor(props) {
        super(props);
        this.handleReasonSelect = (item) => {
            this.setState({ reason: item });
        };
        this.handleCommentInput = (comment) => {
            this.setState({ comment });
        };
        this.handleCommentRequired = (value) => {
            this.setState({ commentRequired: value });
        };
        this.state = {
            reason: null,
            comment: '',
            commentRequired: false,
        };
    }
    onCancelShipment() {
        this.props.onCancelShipment(this.props.shipment, this.state.reason, this.state.comment);
        this.setState({ reason: null, comment: '', commentRequired: false }, () => {
            this.props.onHide();
        });
    }
    render() {
        if (!this.props.shipment)
            return null;
        const { commentRequired, comment } = this.state;
        const commentMissing = commentRequired && !comment.length;
        const { t } = this.props;
        return (React.createElement(Modal, { show: this.props.show, onHide: () => this.props.onHide(), enforceFocus: false },
            React.createElement(Modal.Header, { closeButton: true },
                React.createElement(Modal.Title, null, `${t('CANCEL_SHIPMENT')} - ${this.props.shipment.shipment_id}`)),
            React.createElement(Modal.Body, null,
                React.createElement(Row, { style: { marginBottom: 10 } },
                    React.createElement(Col, { xs: 12 }, t('CANCEL_SHIPMENT_SPECIFY_REASON'))),
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 12 },
                        React.createElement(SelectReasonCodes, { shipment: this.props.shipment, category: "shipment_cancellation", updateComment: this.handleCommentInput, selectReasonCode: this.handleReasonSelect, updateCommentRequired: this.handleCommentRequired, useDescriptionAsValue: true })))),
            React.createElement(Modal.Footer, null,
                React.createElement(Row, null,
                    React.createElement(Col, { xs: 8 }),
                    React.createElement(Col, { xs: 4 },
                        React.createElement(Button, { disabled: !this.state.reason ||
                                _.isEmpty(this.state.reason) ||
                                commentMissing, onClick: () => this.onCancelShipment(), style: { marginRight: 5 }, bsStyle: "danger" }, t('CANCEL_SHIPMENT')))))));
    }
}
export default withTranslation()(CancelShipmentModal);
